var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.5588 175C58.1362 175 24.5588 141.423 24.5588 100C24.5588 58.5774 58.1362 25 99.5588 25C140.981 25 174.559 58.5774 174.559 100C174.559 141.423 140.981 175 99.5588 175Z",
    fill: "url(#paint0_linear_26801_1445)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3235 52.4133C41.3235 47.0195 45.696 42.6471 51.0897 42.6471H148.752C154.146 42.6471 158.519 47.0195 158.519 52.4133V130.543C158.519 135.937 154.146 140.31 148.752 140.31H51.0897C45.696 140.31 41.3235 135.937 41.3235 130.543V52.4133ZM93.4102 68.6904C93.4102 75.8821 87.5802 81.7121 80.3885 81.7121C73.1968 81.7121 67.3668 75.8821 67.3668 68.6904C67.3668 61.4987 73.1968 55.6687 80.3885 55.6687C87.5802 55.6687 93.4102 61.4987 93.4102 68.6904ZM136.19 127.288H63.6319C61.3438 127.288 60.0603 124.892 61.3996 123.173L81.2274 102.073C82.2877 100.979 84.1293 100.979 85.2454 102.021L94.3417 111.662L111.418 86.7592C112.59 85.1966 115.046 85.2487 116.106 86.8634L138.646 123.381C139.65 125.152 138.311 127.288 136.19 127.288Z",
    fill: "url(#paint1_linear_26801_1445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M78.5881 161C81.6257 161 84.0881 158.538 84.0881 155.5C84.0881 152.462 81.6257 150 78.5881 150C75.5506 150 73.0881 152.462 73.0881 155.5C73.0881 158.538 75.5506 161 78.5881 161Z",
    fill: "#D4D9E2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M106.088 155.5C106.088 158.538 103.626 161 100.588 161C97.5505 161 95.0881 158.538 95.0881 155.5C95.0881 152.462 97.5505 150 100.588 150C103.626 150 106.088 152.462 106.088 155.5Z",
    fill: "#D4D9E2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M121.588 161C124.626 161 127.088 158.538 127.088 155.5C127.088 152.462 124.626 150 121.588 150C118.55 150 116.088 152.462 116.088 155.5C116.088 158.538 118.55 161 121.588 161Z",
    fill: "#D4D9E2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.323 109.706C170.475 109.706 165.735 104.966 165.735 99.1177C165.735 93.2698 170.475 88.5294 176.323 88.5294C182.171 88.5294 186.912 93.2698 186.912 99.1177C186.912 104.966 182.171 109.706 176.323 109.706Z",
    fill: "url(#paint2_linear_26801_1445)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.3 93.2441C174.886 92.6584 175.836 92.6584 176.421 93.2441L180.881 97.7034C181.662 98.4845 181.662 99.7508 180.881 100.532L176.421 104.991C175.836 105.577 174.886 105.577 174.3 104.991C173.714 104.405 173.714 103.456 174.3 102.87L178.052 99.1176L174.3 95.3655C173.714 94.7797 173.714 93.8299 174.3 93.2441Z",
    fill: "url(#paint3_linear_26801_1445)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.3 93.2441C174.886 92.6584 175.836 92.6584 176.421 93.2441L180.881 97.7034C181.662 98.4845 181.662 99.7508 180.881 100.532L176.421 104.991C175.836 105.577 174.886 105.577 174.3 104.991C173.714 104.405 173.714 103.456 174.3 102.87L178.052 99.1176L174.3 95.3655C173.714 94.7797 173.714 93.8299 174.3 93.2441Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6764 109.706C17.8285 109.706 13.0881 104.966 13.0881 99.1177C13.0881 93.2698 17.8285 88.5294 23.6764 88.5294C29.5243 88.5294 34.2646 93.2698 34.2646 99.1177C34.2646 104.966 29.5243 109.706 23.6764 109.706Z",
    fill: "url(#paint4_linear_26801_1445)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.662 93.2441C26.0762 92.6584 25.1264 92.6584 24.5407 93.2441L20.0814 97.7034C19.3003 98.4845 19.3003 99.7508 20.0814 100.532L24.5407 104.991C25.1264 105.577 26.0762 105.577 26.662 104.991C27.2478 104.405 27.2478 103.456 26.662 102.87L22.9098 99.1176L26.662 95.3655C27.2478 94.7797 27.2478 93.8299 26.662 93.2441Z",
    fill: "url(#paint5_linear_26801_1445)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.662 93.2441C26.0762 92.6584 25.1264 92.6584 24.5407 93.2441L20.0814 97.7034C19.3003 98.4845 19.3003 99.7508 20.0814 100.532L24.5407 104.991C25.1264 105.577 26.0762 105.577 26.662 104.991C27.2478 104.405 27.2478 103.456 26.662 102.87L22.9098 99.1176L26.662 95.3655C27.2478 94.7797 27.2478 93.8299 26.662 93.2441Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_1445",
    x1: 24.5588,
    y1: 36.7188,
    x2: 167.527,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_1445",
    x1: 99.921,
    y1: 42.6471,
    x2: 99.921,
    y2: 140.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_1445",
    x1: 168.051,
    y1: 88.5294,
    x2: 192.54,
    y2: 103.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_1445",
    x1: 176.053,
    y1: 93.961,
    x2: 181.628,
    y2: 95.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#FFB7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_1445",
    x1: 15.4043,
    y1: 88.5294,
    x2: 39.8928,
    y2: 103.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_1445",
    x1: 24.9087,
    y1: 93.961,
    x2: 19.3347,
    y2: 95.5883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#FFB7CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSlider);
export default __webpack_public_path__ + "static/media/Image-Slider.b1b5da3d2e93c3a1463a4f76b876e69a.svg";
export { ForwardRef as ReactComponent };